import { ActivatedRoute, RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChildren, ViewChild, QueryList, ElementRef } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { StockService } from '../../../../Services/Stock/stock.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { NotificationService } from '../../../../Services/notification.service';
import { ApiService } from '../../../../Services/api.service';
import { AbstractControl, ValidationErrors } from '@angular/forms';


export function minArrayLength(min: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control instanceof FormArray) {
      return control.length >= min ? null : { minArrayLength: true };
    }
    return null;
  };
}
interface PackagingItem {
  st_id: number;
  st_item_name: string;
  st_item_cost: number;
}

@Component({
  selector: 'app-packaging-stack-form',
  imports: [NgIf, NgFor, ReactiveFormsModule, CommonModule, RouterLink],
  templateUrl: './packaging-stack-form.component.html',
  styleUrl: './packaging-stack-form.component.css',
  standalone: true
})
export class PackagingStackFormComponent implements OnInit {
  packagingDataList: any;
  packagingList: any[] = [];
  deleteWastageDetail(arg0: any) {
    throw new Error('Method not implemented.');
  }

  submitbutton: boolean = true;
  updatebutton: boolean = false;
  packagingStackForm!: FormGroup;
  selectedFirm!: number;
  packagingProductNames: any;
  packagingProductCodes: { st_item_code: string; st_item_name: string }[] = [];
  filteredProductCodes: { st_item_code: string; st_item_name: string }[] = [];
  showDropdown = false;
  activeIndex: number = -1;
  singlePackagingData: any;
  packagingeditId: any;
  editmode: boolean = false;
  minorPackagingList: PackagingItem[] = [];
  finalValueButto: boolean = false;
  majorLoaded = false;
  minorLoaded = false;



  @ViewChild('minorSection') minorSection!: ElementRef;
  @ViewChildren('minorSelect') minorSelects!: QueryList<ElementRef>;


  @ViewChildren('itemRef') itemElements!: QueryList<ElementRef>;
  wastageData: any;

  constructor(
    private fb: FormBuilder,
    private stockService: StockService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private activateroute: ActivatedRoute,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.packagingeditId = this.activateroute.snapshot.params['id'];
    this.editmode = !!this.packagingeditId;

    this.getPackagingProductCodes();
    this.getNamesAndCostList();
    this.getMinorNamesAndCostList();
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      this.selectedFirm = firm?.id;
      this.initForm();
      //this.patchData();
      this.getPackagingList();
    });
  }

  private getFormattedCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = ('0' + (today.getMonth() + 1)).slice(-2);
    const day = ('0' + today.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  initForm() {
    this.packagingStackForm = this.fb.group({
      st_packaging_stack_name: ['', Validators.required],
      st_item_name: ['', Validators.required],
      st_item_category: [''],
      st_type_stack: ['major'],
      st_unit_price: ['', Validators.required],
      st_no_of_primary_minor: ['', Validators.required],
      st_major_after_products: ['', Validators.required],
      st_major_cost_on_minor: ['', Validators.required],
      st_final_valuation: [''],
      st_packaging_form_type: ['create_packaging_stack'],
      st_purity: ['100'],
      st_metal_type: ['Packaging Stack'],
      st_product_code_type: ['Packaging Stack'],
      st_item_code: [''],
      st_firm_id: this.selectedFirm,
      st_minor_packaging_items: this.fb.array([], minArrayLength(1)),
    });

    this.packagingStackForm.get('st_unit_price')?.valueChanges.subscribe(() => this.calculateFinalValuation());
    this.packagingStackForm.get('st_no_of_primary_minor')?.valueChanges.subscribe(() => this.calculateFinalValuation());

    this.packagingItems.valueChanges.subscribe(() => this.calculateFinalValuation());
    // ================================
  //  AUTO SYNC PRIMARY → MAJOR
  // ================================
  this.packagingStackForm
    .get('st_no_of_primary_minor')
    ?.valueChanges.subscribe((val) => {

      if (val !== null && val !== '') {
        this.packagingStackForm
          .get('st_major_after_products')
          ?.setValue(val, { emitEvent: false });
      }

    });


    this.packagingStackForm.get('st_packaging_stack_name')?.valueChanges.subscribe((name: string) => {
      if (name) {
        const randomCode = Math.random().toString(36).substring(2, 6).toUpperCase();
        this.packagingStackForm.patchValue({
          st_item_code: `${name}${randomCode}`
        });
      } else {
        this.packagingStackForm.patchValue({
          st_item_code: ''
        });
      }
    });

    this.packagingStackForm.get('st_item_name')?.valueChanges.subscribe((val) => {
      if (val && typeof val === 'object') {
        this.packagingStackForm.patchValue({
          st_item_category: val.st_item_name || '',
        });
      } else {
        this.packagingStackForm.patchValue({
          st_item_category: val || '',
        });
      }
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    if (
      allowedKeys.includes(event.key) ||
      (event.key >= '0' && event.key <= '9')
    ) {
      return;
    }

    event.preventDefault();
  }
  allowOnlyLetters(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      ' '
    ];

    // Allow navigation + space
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Allow letters only
    const regex = /^[a-zA-Z]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') ?? '';
    if (!/^[a-zA-Z\s]+$/.test(pastedText)) {
      event.preventDefault();
    }
  }


  calculateFinalValuation(): void {
    const majorItemCost = parseFloat(this.packagingStackForm.get('st_unit_price')?.value) || 0;
    const noOfPrimaryMinor = parseFloat(this.packagingStackForm.get('st_no_of_primary_minor')?.value) || 0;
    let majorCostOnMinor = 0;

    if (majorItemCost > 0 && noOfPrimaryMinor > 0) {
      majorCostOnMinor = majorItemCost / noOfPrimaryMinor;
    }

    this.packagingStackForm.get('st_major_cost_on_minor')?.setValue(majorCostOnMinor.toFixed(2), { emitEvent: false });

    let minorItemsTotalCost = 0;
    this.packagingItems.controls.forEach(control => {
      const itemPrice = parseFloat(control.get('st_unit_price')?.value) || 0;
      minorItemsTotalCost += itemPrice;
    });

    const finalValue = majorCostOnMinor + minorItemsTotalCost;
    this.packagingStackForm.get('st_final_valuation')?.setValue(finalValue.toFixed(2), { emitEvent: false });
  }

  get packagingItems(): FormArray {
    return this.packagingStackForm.get('st_minor_packaging_items') as FormArray;
  }

  addPackagingItem(): void {
    this.packagingItems.push(
      this.fb.group({
        st_item_name: [''],
        st_unit_price: [''],
      })
    );
    this.finalValueButto = true;
  }

  onPackagingItemSelectFromArray(index: number): void {
    const formArray = this.packagingStackForm.get('st_minor_packaging_items') as FormArray;
    const itemGroup = formArray.at(index) as FormGroup;

    const selectedItem = itemGroup.get('st_item_name')?.value;

    if (selectedItem && selectedItem.st_item_cost) {
      itemGroup.patchValue({
        st_unit_price: selectedItem.st_item_cost
      });
    } else {
      itemGroup.patchValue({
        st_unit_price: null
      });
    }
  }

  updateUnitPriceFromSupplier(): void {
    const code = parseFloat(this.packagingStackForm.get('st_unit_price')?.value) || 0;
    const NoOfPrimaryMinor = parseFloat(this.packagingStackForm.get('st_no_of_primary_minor')?.value) || 0;

    if (code > 0 && NoOfPrimaryMinor > 0) {
      const unitPrice = code / NoOfPrimaryMinor;
      this.packagingStackForm.get('st_major_cost_on_minor')?.setValue(unitPrice.toFixed(2), { emitEvent: false });
    }
  }

  getPackagingList() {
    this.stockService.getStockEntries().subscribe({
      next: (res: any) => {
        this.packagingDataList = (res.data || [])
          .filter((item: any) => item.st_product_code_type === 'Packaging Stack')
          .map((item: any) => ({
            ...item,
            st_minor_packaging_items: item.st_minor_packaging_items
              ? typeof item.st_minor_packaging_items === 'string'
                ? JSON.parse(item.st_minor_packaging_items)
                : item.st_minor_packaging_items
              : [],
          }))
          .sort((a: any, b: any) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          )
          .slice(0, 5);
      },
      error: () => {
        this.notificationService.showError(
          'Failed to load packaging stack list.',
          'Error'
        );
      }
    });
  }

  getNamesAndCostList(): void {
    this.stockService.getMajorOrMinorDataByType('major').subscribe({
      next: (res) => {
        this.packagingList = res.data.map((item: any) => ({
          st_id: item.st_id,
          st_item_name: item.st_item_name,
          st_item_cost: item.st_unit_price
        }));

        this.majorLoaded = true;
        this.tryPatch();
      }
    });
  }

  tryPatch() {
    if (this.editmode && this.majorLoaded && this.minorLoaded) {
      this.patchData();
    }
  }

  getMinorNamesAndCostList(): void {
    this.stockService.getMajorOrMinorDataByType('minor').subscribe({
      next: (res) => {
        this.minorPackagingList = res.data.map((item: any) => ({
          st_id: item.st_id,
          st_item_name: item.st_item_name,
          st_item_cost: item.st_unit_price
        }));

        this.minorLoaded = true;
        this.tryPatch();
      }
    });
  }



  onPackagingItemSelect(): void {
    const selectedItem = this.packagingStackForm.get('st_item_name')?.value;
    if (selectedItem && selectedItem.st_item_cost) {
      this.packagingStackForm.patchValue({
        st_unit_price: selectedItem.st_item_cost
      });
    } else {
      this.packagingStackForm.patchValue({
        st_unit_price: null
      });
    }
  }

  patchData(): void {
    if (!this.editmode || !this.packagingeditId) return;

    this.stockService.getStockEntryById(this.packagingeditId).subscribe({
      next: (response: any) => {
        const packagingData = response.data;
        if (!this.packagingStackForm || !packagingData) return;

        this.submitbutton = false;
        this.updatebutton = true;

        // 1. Find matching major item object so the dropdown selects it correctly
        const selectedMajorItem = this.packagingList.find(
          item => item.st_item_name === packagingData.st_item_name
        );

        // 2. Patch MAIN form fields
        this.packagingStackForm.patchValue({
          st_packaging_stack_name: packagingData.st_packaging_stack_name ?? '',
          st_item_code: packagingData.st_item_code ?? '',
          st_item_name: selectedMajorItem ?? packagingData.st_item_name ?? '', // Fallback to string if object not found
          st_type_stack: packagingData.st_type_stack ?? 'major',
          st_unit_price: Number(packagingData.st_unit_price) || 0,
          st_no_of_primary_minor: packagingData.st_no_of_primary_minor ?? '',
          st_major_after_products: packagingData.st_major_after_products ?? '',

          // IMPORTANT: Patch these fields so they aren't empty strings
          st_major_cost_on_minor: packagingData.st_major_cost_on_minor ?? '',
          st_final_valuation: packagingData.st_final_valuation ?? '',

          st_purity: packagingData.st_purity || 100,
          st_metal_type: packagingData.st_metal_type ?? 'Packaging Stack',
          st_product_code_type: packagingData.st_product_code_type ?? 'Packaging Stack',
        }, { emitEvent: false }); // Suppress events to avoid partial calculations during patch

        // 3. Patch MINOR ITEMS (FormArray)
        this.packagingItems.clear();

        const minors = Array.isArray(packagingData.st_minor_packaging_items)
          ? packagingData.st_minor_packaging_items
          : JSON.parse(packagingData.st_minor_packaging_items || '[]');

        minors.forEach((minor: any) => {

          const matchedMinor = this.minorPackagingList.find(
            (m: PackagingItem) => m.st_item_name === minor.minor_name
          );

          this.packagingItems.push(
            this.fb.group({
              st_item_name: matchedMinor ?? null,   // MUST be object
              st_unit_price: minor.minor_cost ?? 0  // ✅ correct key
            })
          );
        });
        setTimeout(() => {
          this.packagingItems.controls.forEach((_, i) =>
            this.onPackagingItemSelectFromArray(i)
          );
        });

        // 4. Show the final value section if we have items
        if (this.packagingItems.length > 0) {
          this.finalValueButto = true;
        }

        // 5. CRITICAL: Force a recalculation now that all data is loaded.
        // This ensures the displayed "Final Value" is mathematically correct based on the inputs.
        this.calculateFinalValuation();
      },
      error: (error) => {
        console.error('Patch error:', error);
        this.notificationService.showError('Failed to load data', 'Error');
      }
    });
  }

  onSubmit() {

    // CASE 1: No minor rows
    if (this.packagingItems.length === 0) {
      this.notificationService.showError(
        'Please add at least one minor packaging item.',
        'Validation'
      );

      // Add ONE minor
      this.addPackagingItem();

      setTimeout(() => {
        // Scroll
        this.minorSection?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        // Mark ONLY first minor touched
        const firstMinor = this.packagingItems.at(0);
        firstMinor.get('st_item_name')?.markAsTouched();

        // Focus dropdown
        this.minorSelects?.first?.nativeElement.focus();
      });

      return;
    }

    // CASE 2: Minor exists but first is empty
    const firstMinor = this.packagingItems.at(0);
    const firstMinorValid =
      firstMinor.get('st_item_name')?.value &&
      firstMinor.get('st_unit_price')?.value;

    if (!firstMinorValid) {
      this.notificationService.showError(
        'Please select at least one minor packaging item.',
        'Validation'
      );

      // Mark ONLY first minor touched
      firstMinor.get('st_item_name')?.markAsTouched();
      firstMinor.get('st_unit_price')?.markAsTouched();

      setTimeout(() => {
        this.minorSection?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        this.minorSelects?.first?.nativeElement.focus();
      });

      return;
    }

    //  CASE 3: Other form errors
    if (this.packagingStackForm.invalid) {
      this.packagingStackForm.markAllAsTouched();
      this.notificationService.showError(
        'Please fix the highlighted errors before submitting.',
        'Validation'
      );
      return;
    }

    //  SUBMIT
    const dataToSend = this.prepareFormData();

    this.stockService.createStockEntry(dataToSend).subscribe({
      next: () => {
        this.notificationService.showSuccess(
          'Packaging Stack data stored successfully!',
          'Success'
        );
        this.getPackagingList();
        this.getPackagingProductCodes();
        this.onClear();
      },
      error: () => {
        this.notificationService.showError(
          'Failed to store Packaging Stack data.',
          'Error'
        );
      }
    });
  }

  onClear() {
    this.packagingStackForm.reset({
      st_type_stack: 'major',
      st_purity: '100',
      st_metal_type: 'Packaging Stack',
      st_product_code_type: 'Packaging Stack',
      st_packaging_form_type: 'create_packaging_stack',
      st_firm_id: this.selectedFirm,
      st_major_after_products: '',
    });
  }

  getPackagingProductCodes(): void {
    this.stockService.getPackagingProductCode().subscribe((res: any) => {
      this.packagingProductCodes = Array.isArray(res?.data) ? res.data : [];
      this.filteredProductCodes = [...this.packagingProductCodes];
    });
  }

  onProductCodeInput(): void {
    const input = this.packagingStackForm.get('st_item_code')?.value?.toLowerCase() || '';

    this.filteredProductCodes = this.packagingProductCodes.filter(item =>
      item.st_item_code.toLowerCase().includes(input) ||
      item.st_item_name.toLowerCase().includes(input)
    );

    this.activeIndex = -1;
    this.showDropdown = true;

    const exactMatch = this.packagingProductCodes.find(item =>
      item.st_item_code.toLowerCase() === input
    );

    if (exactMatch) {
      this.getDataByProductCode(exactMatch.st_item_code);
    }
  }

  onInputFocus(): void {
    this.filteredProductCodes = [...this.packagingProductCodes];
    this.showDropdown = true;
  }

  selectProductCode(code: string): void {
    this.packagingStackForm.get('st_item_code')?.setValue(code);
    this.showDropdown = false;
    this.getDataByProductCode(code);
  }

  hideDropdownDelayed(): void {
    setTimeout(() => this.showDropdown = false, 200);
  }

  onKeyDown(event: KeyboardEvent): void {
    const maxIndex = this.filteredProductCodes.length - 1;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeIndex = this.activeIndex < maxIndex ? this.activeIndex + 1 : 0;
      this.scrollToActiveItem();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : maxIndex;
      this.scrollToActiveItem();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (this.activeIndex >= 0) {
        const selected = this.filteredProductCodes[this.activeIndex];
        this.selectProductCode(selected.st_item_code);
      } else {
        const typedCode = this.packagingStackForm.get('st_item_code')?.value;
        if (typedCode) {
          this.getDataByProductCode(typedCode);
        }
      }
    }
  }

  scrollToActiveItem(): void {
    const itemsArray = this.itemElements.toArray();
    const el = itemsArray[this.activeIndex];
    if (el) {
      el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  getDataByProductCode(code: string): void {
    this.stockService.getSingleDataByProductCode(code).subscribe((res: any) => {
      this.singlePackagingData = res.data[0];

      if (this.singlePackagingData) {
        this.packagingStackForm.patchValue({
          st_item_name: this.singlePackagingData.st_item_name ?? '',
          st_type_stack: this.singlePackagingData.st_type_stack ?? '',
          st_unit_price: this.singlePackagingData.st_unit_price ?? '',
          st_no_of_primary_minor: this.singlePackagingData.st_no_of_primary_minor ?? '',
          st_major_after_products: this.singlePackagingData.st_major_after_products ?? '',
        });
      }
    });
  }

  prepareFormData(): any {
    const rawFormData = this.packagingStackForm.getRawValue();

    // ✅ Extract MAJOR info (from same stack)
    let majorStockId: number | null = null;
    let majorName: string | null = null;

    if (typeof rawFormData.st_item_name === 'object') {
      majorStockId = rawFormData.st_item_name.st_id;
      majorName = rawFormData.st_item_name.st_item_name;
      rawFormData.st_item_name = majorName;
    }

    // ✅ Build MINOR JSON with BOTH IDs
    rawFormData.st_minor_packaging_items = (this.packagingItems.getRawValue() || []).map((item: any) => {

      // Selected from dropdown
      if (item.st_item_name && typeof item.st_item_name === 'object') {
        return {
          // 🔑 IDs (THIS FIXES EVERYTHING)
          minor_stock_id: item.st_item_name.st_id,
          major_stock_id: majorStockId,

          // 🧾 Names (for invoice / UI)
          minor_name: item.st_item_name.st_item_name,
          major_name: majorName,

          // 💰 Cost
          minor_cost: item.st_item_name.st_item_cost ?? item.st_unit_price
        };
      }

      // Fallback (edit mode / legacy)
      return {
        minor_stock_id: null,
        major_stock_id: majorStockId,
        minor_name: item.st_item_name,
        major_name: majorName,
        minor_cost: item.st_unit_price
      };
    });

    return rawFormData;
  }

  editpackage() {
    if (this.packagingStackForm.invalid) {
      this.packagingStackForm.markAllAsTouched();
      this.notificationService.showError('Please fix errors before updating.', 'Validation');
      return;
    }

    const dataToSend = this.prepareFormData();

    this.stockService.updateStockEntry(this.packagingeditId, dataToSend).subscribe({
      next: (response: any) => {
        this.notificationService.showSuccess("Packaging updated successfully", "Success");
        this.onClear(); // Clear form and reset state
        this.getPackagingList(); // Refresh list
        this.submitbutton = true; // Switch buttons back
        this.updatebutton = false;
        this.packagingeditId = null; // Clear ID
        this.editmode = false;
      },
      error: (err) => {
        console.error('Update Error:', err);
        this.notificationService.showError("Failed to update packaging", "Error");
      }
    });
  }

  deletePackaging(id: any) {
    this.apiService.delete(`stocks/${id}`).subscribe(
      (response: any) => {
        this.notificationService.showSuccess('Packaging item deleted successfully!', 'Success');
        this.getPackagingList();
      },
      (error: any) => {
        this.notificationService.showError('Failed to delete packaging item. Please try again.', 'Error');
      }
    );
  }

  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === 'Enter') {
      keyboardEvent.preventDefault();

      const target = keyboardEvent.target as HTMLElement;
      const form = target.closest('form');
      if (!form) return;

      const focusable = Array.from(
        form.querySelectorAll<HTMLElement>('input, select, textarea, button')
      ).filter((el) => !el.hasAttribute('disabled') && el.tabIndex !== -1);

      const index = focusable.indexOf(target);
      if (index > -1 && index + 1 < focusable.length) {
        focusable[index + 1].focus();
      }
    }
  }
}
